<template>
  <tbody>
  <tr :class="['clickable', { disabled: !isActiveWithOperator, updated: isLastVisited(entity.id) }]" @click.stop="goToDetail($event, entity.id)" >
    <td class="no_padding drag_drop"><span></span></td>
    <td class="no_padding">
      <input
          type="checkbox"
          :id="entity.id"
          :value="entity.id"
          @click.stop
          @change="onChange"
          :checked="isChecked"
      />
      <label :for="entity.id" @click.stop v-translate>Vybrat</label>
    </td>
    <td :data-th="'Příjmení jméno' | translate" class="first_data">
      <strong>{{ entity.surname }} {{ entity.firstname }}</strong>
      <span
          v-if="showClock"
          class="time"
          :title="'Časově omezená platnost' | translate"
          v-translate>
			</span>
      <span
          v-if="!isOperatorActive"
          class="inactive_operator"
          :title="'Operátor je neaktivní' | translate"
          v-translate>
			</span>
      <span
          v-if="isTester"
          class="tester"
          :title="'Testovací odběratel' | translate"
          v-translate>
			</span>
      <span
          v-if="isPromo"
          class="promo"
          :title="'Promo odběratel' | translate"
          v-translate>
			</span>
    </td>
    <td :data-th="'Název firmy' | translate">{{ entity.company_name }}</td>
    <td v-if="$_readActionAllowedAll" :data-th="'Operátor' | translate">
      <entity-link :id="entity.id_operator" type="operator">{{ entity.operator_name }}</entity-link>
    </td>
    <td :data-th="'Typ subjektu' | translate">{{ subjectTypeDisplayValue }}</td>
    <td :data-th="'Typ odběratele' | translate">{{ entity.subscriber_type_name }}</td>
    <td :data-th="'Město' | translate">{{ entity.address.town }}</td>
    <td :data-th="'Spárovaná zařízení' | translate">{{ entity.active_devices_count }}</td>
    <td :data-th="'Poslední start zařízení' | translate" v-html="$_date_formatFull(entity.last_device_start_log)"></td>
    <td :data-th="'Vloženo' | translate" v-html="$_date_formatFull(entity.date_created)"></td>
    <td :data-th="'Upraveno' | translate" class="right last_data"
        v-html="$_date_formatFull(entity.date_updated)"></td>
    <td class="no_padding edit">
      <div class="edit_inner">
        <a
            v-if="!isActiveBool && $_updateActionAllowed"
            class="btn btn_action btn_grey btn_enable"
            :class="{ btn_inactive: !isOperatorActive }"
                        :title="activateTitle"
            @click.prevent.stop="emitUpdateSubscriber({active: true})">
        </a>
        <a
            v-if="isActiveBool && $_updateActionAllowed"
            class="btn btn_action btn_grey btn_disable"
            :class="{ btn_inactive: !isOperatorActive }"
                        :title="deactivateTitle"
            @click.prevent.stop="emitUpdateSubscriber({active: false})">
        </a>
        <a v-if="$_deleteActionAllowed"
            class="btn btn_action btn_delete"
                        :title="'Smazat' | translate"
            @click.prevent.stop="emitDeleteSubscriber"
            v-translate>Smazat
        </a>
      </div>
    </td>
  </tr>
  </tbody>
</template>

<script>
import userSettings from "@/components/mixins/user-settings"
import rowActions from "@/components/mixins/row-actions"
import EntityLink from "../../common/EntityLink.vue";

export default {
  name: "SubscriberRow",
  components: { EntityLink },
  mixins: [userSettings, rowActions],
  data() {
    return {
      moduleName: 'subscribers'
    }
  },
  props: {
    entity: Object,
    selectedSubscribers: Array
  },
  computed: {
    isActiveBool() {
      return this.entity.active
    },
    isActiveWithOperator() {
      return this.isOperatorActive && this.isActiveBool && Boolean(this.entity.is_date_range_active)
    },
    isOperatorActive() {
      return Boolean(this.entity.operator_active);
    },
    isChecked() {
      return this.selectedSubscribers.indexOf(String(this.entity.id)) > -1
    },
    subjectTypeDisplayValue() {
      return this.entity.subject_type === 'person' ? this.$gettext('Fyzická osoba') : this.$gettext('Právnická osoba')
    },
    showClock() {
      return Boolean(this.isActiveBool && this.entity.has_any_activation_date)
    },
    activateTitle() {
      return this.isOperatorActive ? this.$gettext('Aktivovat') : this.$gettext('Operátor je neaktivní')
    },
    deactivateTitle() {
      return this.isOperatorActive ? this.$gettext('Deaktivovat') : this.$gettext('Operátor je neaktivní')
    },
    isTester(){
      return Boolean(this.entity.subscription_type === 'tester');
    },
    isPromo(){
      return Boolean(this.entity.subscription_type === 'promo');
    }
  },
  methods: {
    onChange: function (e) {
      this.$emit('input', e)
    },
    goToDetail(e, id) {
      this.$router.push({name: 'subscriberDetail', params: {id: id}})
    },
    emitUpdateSubscriber(params) {
      if (!this.isOperatorActive) {
        return
      }
      this.$emit('updateSubscriber', {'id': this.entity.id, 'params': params})
    },
    emitDeleteSubscriber() {
      this.$emit('deleteSubscriber', this.entity.id)
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/SubscriberRow.vue